module.exports = __webpack_public_path__ + "img/10beecoins.db540198.svg";